/* eslint-disable */
export function compareByPropertyAsc(a, b, compareProperty) {
  if (a[compareProperty] > b[compareProperty]) {
    return -1;
  }
  if (a[compareProperty] < b[compareProperty]) {
    return 1;
  }
  return 0;
}

export function compareByPropertyDesc(a, b, compareProperty) {
  if (a[compareProperty] < b[compareProperty]) {
    return -1;
  }
  if (a[compareProperty] > b[compareProperty]) {
    return 1;
  }
  return 0;
}
